import { z } from "zod";
/**
 * Factory function to create CreatePartnerValidator with translations
 */
export const createCreatePartnerValidator = (t) => z.object({
    firstName: z
        .string()
        .min(1, t("validation.partners.firstNameRequired"))
        .max(255, t("validation.partners.firstNameTooLong")),
    lastName: z
        .string()
        .min(1, t("validation.partners.lastNameRequired"))
        .max(255, t("validation.partners.lastNameTooLong")),
    email: z.string().email(t("validation.email")),
    grossMonthlySalary: z.number().min(0, t("validation.partners.grossSalaryPositive")).default(0),
    netMonthlySalary: z.number().min(0, t("validation.partners.netSalaryPositive")).default(0),
});
/**
 * Factory function to create UpdatePartnerValidator with translations
 */
export const createUpdatePartnerValidator = (t) => z.object({
    firstName: z
        .string()
        .min(1, t("validation.partners.firstNameRequired"))
        .max(255, t("validation.partners.firstNameTooLong"))
        .optional(),
    lastName: z
        .string()
        .min(1, t("validation.partners.lastNameRequired"))
        .max(255, t("validation.partners.lastNameTooLong"))
        .optional(),
    email: z.email(t("validation.email")).optional(),
    grossMonthlySalary: z.number().min(0, t("validation.partners.grossSalaryPositive")).optional(),
    netMonthlySalary: z.number().min(0, t("validation.partners.netSalaryPositive")).optional(),
});
